import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  CustomInput,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap";
import { api, userService } from "../../_services";
import moment from "moment";
import DatePicker from "react-datepicker";
import { currencyFormatter } from "../../_services/currencyFormatter";
import Loader from "react-loaders";
import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import Moment from "react-moment";
import QuickBooksLoadingModal from "../Intuit/QuickBooksLoadingModal";

const PushInvoicesToQuickbooksModal = ({
  isOpen,
  toggleModal,
  invoiceList,
  invoiceStatusList,
  entity,
  reloadData,
  isLoading,
  props,
}) => {
  const currentUser = userService.getLoggedInUser();
  const [invoicesToSync, setInvoicesToSync] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [quickBooksError, setQuickBooksError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setQuickBooksError("");
      loadData();
    }
  }, [isOpen, invoiceList]);

  const loadData = () => {
    let finalStatus = invoiceStatusList.find(
      (x) => x.name.toLowerCase() == "final - submitted",
    );
    let finalHoldStatus = invoiceStatusList.find(
      (x) => x.name.toLowerCase() == "final - hold",
    );
    if (finalStatus != undefined && finalStatus != null) {
      let filteredInvoices = invoiceList.filter(
        (x) =>
          (x.invoiceStatusId == finalStatus.invoiceStatusId ||
            x.invoiceStatusId == finalHoldStatus.invoiceStatusId) &&
          !x.quickBooksDisableSyncing &&
          x.outstandingAmount > 0 &&
          (x.quickBooksInvoiceId == undefined ||
            x.quickBooksInvoiceId == null ||
            x.quickBooksInvoiceId == "") &&
          x.matterIds != undefined &&
          x.matterIds != null &&
          x.matterIds != "" &&
          x.matterIds.indexOf(",") == -1 &&
          moment(entity.quickBooksStartDate).isSameOrBefore(
            moment(x.startDate),
            "day",
          ),
      );
      setInvoicesToSync(filteredInvoices.slice(0, 50));
    } else {
      setInvoicesToSync([]);
    }
  };

  const save = async () => {
    setIsSubmitting(true);

    try {
      let invoicesPayload = invoicesToSync.map((i) => {
        return {
          invoiceId: i.invoiceId,
          matterId: i.matterIds,
        };
      });

      let payload = {
        invoices: invoicesPayload,
      }

      await api.createQuickBooksInvoicesBatch(currentUser.entityId, payload);

    } catch (error) {
      setQuickBooksError(error);
    } finally {
      setIsSubmitting(false);
      reloadData();
    }
  };

  const invoiceColumns = [
    {
      dataField: "invoiceNumber",
      text: "Invoice",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "matterList",
      text: "Matter",
      sort: true,
      headerStyle: () => {
        return { width: "17%" };
      },
    },
    {
      dataField: "clientEntityName",
      text: "Client",
      sort: true,
      headerStyle: () => {
        return { width: "18%" };
      },
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return <Moment format="MM/DD/YYYY">{cellContent}</Moment>;
      },
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        return <Moment format="MM/DD/YYYY">{cellContent}</Moment>;
      },
    },
    {
      dataField: "invoiceTotal",
      sort: true,
      text: "Amount",
      headerStyle: () => {
        return { width: "15%" };
      },
      formatter: (cell, row) => {
        return currencyFormatter("$", cell, true);
      },
    },
    {
      dataField: "quickBooksFailedSyncing",
      sort: true,
      text: "Failed to Sync",
      headerStyle: () => {
        return { width: "15%" };
      },
      formatter: (cell, row) => {
        return cell == true ? (
          <span style={{ color: "red", fontWeight: "bold" }}>Yes</span>
        ) : (
          ""
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={isOpen}
        size="xl"
        toggle={() => {
          toggleModal();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Push Invoices to QuickBooks
          </h5>
          <button
            type="button"
            onClick={() => {
              toggleModal();
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {isLoading && <Loader style={{}} type="ball-pulse" active />}
          {!isLoading && (
            <Row style={{ marginTop: "30px" }}>
              <Col md="12">
                <Card className="main-card mb-3">
                  <CardBody>
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "600px", overflowY: "auto" }}
                    >
                      <BootstrapTable
                        bootstrap4
                        striped
                        bordered={false}
                        keyField="invoiceId"
                        data={invoicesToSync}
                        columns={invoiceColumns}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
        <div
          className="modal-footer"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary save-user"
            onClick={save}
            disabled={isSubmitting}
          >
            Push Invoices to QuickBooks
          </button>
        </div>
      </Modal>
      <QuickBooksLoadingModal
        isLoading={isSubmitting}
        error={quickBooksError}
        navigateToQuickBooksPage={() => props.history.push("/quickbooks")}
      />
    </>
  );
};

export default PushInvoicesToQuickbooksModal;
